import React from 'react';
import styles from './StatusCardView.module.scss';

export interface StatusCardViewProps {
  isOnline: boolean;
  deviceId?: string;
  lastSeen?: string;
  statusText?: string;
  showLastSeen?: boolean;
  formattedDate?: string | null;
}

export default function StatusCardView({
  isOnline,
  deviceId,
  lastSeen,
  statusText,
  showLastSeen = true,
  formattedDate
}: StatusCardViewProps) {
  const getStatusInfo = () => {
    if (isOnline) {
      return {
        text: statusText || 'En ligne',
        className: styles.statusOnline,
        icon: '🟢',
        pulse: true
      };
    } else {
      return {
        text: statusText || 'Hors ligne',
        className: styles.statusOffline,
        icon: '🔴',
        pulse: false
      };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={styles.statusCard}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>Statut du Compteur</h3>
          {deviceId && (
            <span className={styles.deviceId}>ID: {deviceId}</span>
          )}
        </div>
      </div>
      
      <div className={styles.content}>
        <div className={styles.statusContainer}>
          <div className={[styles.statusIndicator, statusInfo.className].join(' ')}>
            <div className={styles.statusIcon}>
              <span className={styles.iconEmoji}>{statusInfo.icon}</span>
              {statusInfo.pulse && <div className={styles.pulseRing}></div>}
            </div>
            
            <div className={styles.statusText}>
              <div className={styles.statusLabel}>{statusInfo.text}</div>
              {showLastSeen && lastSeen && (
                <div className={styles.lastSeen}>
                  Dernière activité: {lastSeen}
                </div>
              )}
              {formattedDate && (
                <div className={styles.date}>
                  {formattedDate}
                </div>
              )}
            </div>
          </div>
          
          <div className={styles.statusBar}>
            <div 
              className={[
                styles.statusBarFill,
                isOnline ? styles.statusBarOnline : styles.statusBarOffline
              ].join(' ')}
            ></div>
          </div>
        </div>
        
        <div className={styles.additionalInfo}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Connexion:</span>
            <span className={[styles.infoValue, isOnline ? styles.infoValueOnline : styles.infoValueOffline].join(' ')}>
              {isOnline ? 'Active' : 'Inactive'}
            </span>
          </div>
          
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>État:</span>
            <span className={[styles.infoValue, isOnline ? styles.infoValueOnline : styles.infoValueOffline].join(' ')}>
              {isOnline ? 'Opérationnel' : 'Arrêté'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

